import React from "react";

const MinusIcon = () => {
    return (
        <svg
            width="7"
            height="2"
            viewBox="0 0 7 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 1H7" stroke="#004170" />
        </svg>
    );
};

export default MinusIcon;



// WEBPACK FOOTER //
// ./src/components/CollapsibleTable/MinusIcon.tsx